module.exports = __webpack_public_path__ + "static/img/logotitle.fb90104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/logotitle.jpg
// module id = tR6u
// module chunks = 7